import { Injectable } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';
import { Business } from 'src/app/models/Businesses';

import { AuthService } from '../auth.service';
import { BackEndService } from '../backEnd.service';
import { LocalDbService } from '../localDb.service';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  business_request;
  business: Business = new Business;
  businessList: Business[] = [];

  constructor(private backEnd: BackEndService, private auth: AuthService, private localDb: LocalDbService) {
  }

  getBusiness(id, variable?: string) {
    variable = variable ?? "id";
    return new Promise((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.BUSINESS, [[variable, id]], 0, 100, 'created_at', false).then((businessList: Business[]) => {
        this.businessList = businessList;
        for (let business of this.businessList) {
          if (business.creator && ((typeof business.creator === 'string'))) {
            business.creator = JSON.parse(business.creator);
          }
        }
        console.log(this.businessList);
        resolve(true);
      })
    })
  }
  getUserBusiness(empId, feedId, type): Promise<Business[]> {
    return new Promise((resolve) => {
      this.backEnd.searchObject(appConfig.STORAGE_TABLE.BUSINESS, [["emp_id", empId], ["feed_id", feedId], ["type", type]]).then((businessList: Business[]) => {
        resolve(businessList);
      })
    })
  }


  saveObject() {
    return new Promise((resolve) => {

      this.business.created_by = this.auth.loggedInEmployee.user.id;
      this.backEnd.saveObject(appConfig.STORAGE_TABLE.BUSINESS, this.business).then((response) => {
        if (response) {
          this.businessList.push(this.business);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

}
